import { toast, ToastPosition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const DURATION = {
  short: 2000,
  medium: 4000,
  long: 6000,
};

export const POSITION: Record<string, ToastPosition> = {
  "bottom-center": "bottom-center",
  "bottom-left": "bottom-left",
  "bottom-right": "bottom-right",
  "top-center": "top-center",
  "top-left": "top-left",
  "top-right": "top-right",
};
export const OrbToast = (
  message: string,
  position:
    | "bottom-center"
    | "bottom-left"
    | "bottom-right"
    | "top-center"
    | "top-left"
    | "top-right" = "top-right",
  duration: "short" | "medium" | "long" = "medium",
  type: "info" | "success" | "warning" | "error" | "default" = "success"
) => {
  const toast_position = POSITION[position];
  const toast_duration = DURATION[duration];
  message ? toast(message, {
    position: toast_position,
    autoClose: toast_duration,
    type: type,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  }) : void null;
};
